import { ReactElement } from 'react';
import { HStack, Text, Button } from '@chakra-ui/react';
import { FileIcon, FolderIcon } from 'assets/icons/v2';

export enum SectionVariant {
  FOLDER = 'FOLDER',
  ARTICLE = 'ARTICLE',
  MEDICATION = 'MEDICATION',
}

type SectionTitleProps = {
  variant: SectionVariant;
  hasButton: boolean;
  onClickButton?: () => void;
  buttonContent?: React.ReactElement | string;
};

export const SectionTitle = ({
  variant,
  hasButton,
  onClickButton,
  buttonContent,
}: SectionTitleProps): ReactElement => {
  const getHeader = (): ReactElement => {
    switch (variant) {
      case SectionVariant.FOLDER:
        return (
          <>
            <FolderIcon mb="5px" mr="5px" h="22px" w="22px" /> Ordner
          </>
        );
      case SectionVariant.ARTICLE:
        return (
          <>
            <FileIcon mb="5px" mr="5px" h="22px" w="22px" /> Lernkarte
          </>
        );
      case SectionVariant.MEDICATION:
        return (
          <>
            <FileIcon mb="5px" mr="5px" h="22px" w="22px" /> Medikamente
          </>
        );
      default:
        return (
          <>
            <FileIcon mb="5px" mr="5px" h="22px" w="22px" /> Lernkarte
          </>
        );
    }
  };
  return (
    <HStack justifyContent="space-between">
      <Text data-cy="contentInFolder" textStyle="h4.regular" color="text.primary" maxWidth="55%">
        {getHeader()}
      </Text>
      {hasButton && (
        <Button
          bg="transparent"
          variant="tertiary"
          color="text.accent"
          fontWeight="regular"
          onClick={onClickButton}
          outline="none"
          _focus={{
            outline: 'none',
            background: 'transparent',
          }}
        >
          {buttonContent}
        </Button>
      )}
    </HStack>
  );
};
